import { Controller } from "@hotwired/stimulus"

// Accept modal controller — used on the pitch detail page
// for assigning general-pool pitches to a specific event.
export default class extends Controller {
  // Currently a simple form — no additional JS needed.
  // Reserved for future enhancements like inline validation
  // or date picker integration.
}
